import styled, { css } from 'styled-components';

export interface CardBlockProps {
	flex?: string;
	showGuttersTop?: boolean;
	padding?: string;
}

/**
 * `CardBlock` is a basic building stone used inside a cards.
 *
 * A CardBlock contains the background seen in cards, padding and flexbox attributes.
 */
const CardBlock = styled.div<CardBlockProps>`
	display: flex;
	flex: ${({ flex }) => flex};

	${({ showGuttersTop }) =>
		showGuttersTop &&
		css`
			margin-top: 2px;
		`}

	padding: ${({ padding }) => padding};
	font: var(--caption);
`;

CardBlock.defaultProps = {
	showGuttersTop: false,
	flex: '1',
	padding: '0 12px 12px 12px'
};

export default CardBlock;
